import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import styled from 'styled-components';
import { __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';

var NoResultsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "uiln16-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;padding:", ";padding-bottom:0;height:calc(100% - 36px);overflow:auto;"], function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.s);
});

function NoResults(_ref) {
  var innerRef = _ref.innerRef,
      rowRenderer = _ref.rowRenderer,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["innerRef", "rowRenderer", "children"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoResultsContainer, _extends({}, rest, {
    innerRef: innerRef
  }), children), rowRenderer({}, {
    style: {
      visibility: 'hidden',
      marginBottom: 0
    }
  }, {}));
}

export default NoResults;
//# sourceMappingURL=NoResults.js.map
